/* @jsx m */
import m from 'mithril';

export default class GameContainer {
  clickHandler(attrs) {
    return attrs.handler(attrs.choiceIndex);
  }

  view(vnode) {
    let classes = ["waves-effect", "waves-light", "btn", "choice-btn"];
    if (!vnode.attrs.visible) classes.push('hide');
    classes = classes.concat(vnode.attrs.styles);

    return (
      <button className={classes.join(' ')} onclick={this.clickHandler.bind(this, vnode.attrs)}>
        {vnode.children}
      </button>
    );
  }
}
